const AssetType = {
	IMAGE: 'image',
	DOCUMENT: 'doc'
};

AssetType.all = Object.values( AssetType );

export default Object.freeze( AssetType );
